import { useEffect, useState } from "react";

import { getRandomBufo, getRandomBufoCaption } from "@/pages/BufoPage/bufo";

const BufoPage = () => {
  const [bufo, setBufo] = useState<string>("");
  const [caption, setCaption] = useState<string>("");

  useEffect(() => {
    setBufo(getRandomBufo());
    setCaption(getRandomBufoCaption());
  }, []);

  return (
    <div className="mt-40 flex w-full flex-col items-center justify-center">
      <div className="flex">
        <img src={bufo} alt="Random Bufo" style={{ width: "200px", height: "auto" }} />
      </div>
      <div className="mt-8 flex w-2/3 text-center font-mono text-sm">
        <p>{caption}</p>
      </div>
    </div>
  );
};

export default BufoPage;
